import home from './src/home.vue'

let views = {
    home
};

export default views;